var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTermination(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.794 5.598H6.206C3.883 5.598 2 7.494 2 9.834v31.93C2 44.104 3.883 46 6.206 46h35.588C44.117 46 46 44.103 46 41.764V9.834c0-2.34-1.883-4.236-4.206-4.236z",
    fill: "#E69B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11.58v30.184a4.252 4.252 0 01-1.232 2.995A4.192 4.192 0 0141.794 46H8.59l-3.22-3.669L36.514 21.55l5.465-12.921L46 11.58z",
    fill: "#BF8055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.368 8.115H7.64a2.826 2.826 0 00-2.816 2.836v29.697a2.826 2.826 0 002.816 2.836h32.727a2.826 2.826 0 002.816-2.836V10.95a2.826 2.826 0 00-2.816-2.836z",
    fill: "#FAFEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64 8.115h32.72a2.8 2.8 0 011.99.83 2.837 2.837 0 01.825 2.006v6.115H4.825V10.96a2.853 2.853 0 01.821-2.011 2.815 2.815 0 011.995-.834z",
    fill: "#FFBF66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.393 15.39c1.681 0 3.045-1.373 3.045-3.066 0-1.693-1.364-3.066-3.045-3.066-1.682 0-3.045 1.373-3.045 3.066 0 1.694 1.363 3.066 3.045 3.066zM35.607 15.39c1.682 0 3.045-1.373 3.045-3.066 0-1.693-1.363-3.066-3.045-3.066-1.681 0-3.044 1.373-3.044 3.066 0 1.694 1.363 3.066 3.044 3.066z",
    fill: "#FAFEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.401 2h-.008c-.86 0-1.558.702-1.558 1.569v9.251c0 .867.697 1.57 1.558 1.57h.008c.86 0 1.558-.703 1.558-1.57V3.57c0-.867-.697-1.569-1.558-1.569zM35.607 2H35.6c-.86 0-1.558.702-1.558 1.569v9.251c0 .867.697 1.57 1.558 1.57h.008c.86 0 1.558-.703 1.558-1.57V3.57c0-.867-.697-1.569-1.558-1.569z",
    fill: "#385666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.126 20.433L10.8 38.335a2.253 2.253 0 00.745 3.123c.342.205.732.314 1.13.315h22.624c.4.003.793-.102 1.139-.304a2.256 2.256 0 00.762-3.134L25.874 20.433a2.205 2.205 0 00-3.749 0z",
    fill: "#FFBF66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.947 23.862h-.008c-.89 0-1.61.726-1.61 1.622v7.683c0 .896.72 1.622 1.61 1.622h.008c.89 0 1.61-.726 1.61-1.622v-7.683c0-.896-.72-1.622-1.61-1.622zM23.947 36.642h-.008c-.89 0-1.61.726-1.61 1.621v.01c0 .895.72 1.621 1.61 1.621h.008c.89 0 1.61-.726 1.61-1.622v-.009c0-.895-.72-1.621-1.61-1.621z",
    fill: "#FAFEFF"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h44v44H0z"
  })))));
}
export default SvgTermination;